<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h5>{{!filtroPeriodo ? 'Filtrar Categoría' : 'Filtrar Periodo'}}</h5>
        </div>
    </div>
    <div class="row">
        <div class="col-6" *ngIf="!filtroPeriodo">
            <div class="row rowCategorias">
                <div class="col-2 categoria" *ngFor="let categoria of categorias"
                    (click)="seleccionCategoria(categoria.id)" [ngClass]="categoria.id === seleccionado ? 'activo' : ''"
                    style="cursor: pointer;">
                    <img [src]="categoria.imagen" alt="Categoria">
                    <span>{{categoria.nombre}}</span>
                </div>
            </div>
        </div>
        <div class="col-6" *ngIf="filtroPeriodo">
            <div class="row rowCategorias">
                <div class="col-2 categoria" *ngFor="let periodo of periodos" (click)="seleccionarPeriodo(periodo.id)"
                    [ngClass]="periodo.id === periodoSeleccionado ? 'activo' : ''" style="cursor: pointer;">
                    <span>{{periodo.periodo}}</span>
                </div>
            </div>
        </div>
        <div class="col-1">

        </div>
        <div class="col-5 d-flex flex-column justify-content-center">
            <div class="row w-100">
                <div class="form-group container-search">
                    <form [formGroup]="form">
                        <button (click)="buscar()">
                            <svg [cIcon]="icons.cilSearch" size="xl" title="Buscar"
                                style="color: white !important;"></svg>
                        </button>
                        <input class="form-control" type="text" name="nominado" id="nominado"
                            placeholder="Buscar Nominado" (keyup)="buscar()" formControlName="nominado">
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>